exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-bar{position:relative;z-index:2;flex-shrink:0;margin-top:40px}.nav-bar__button{display:inline-block;padding:10px 30px;font-family:\"CharriotDeluxe\",serif;font-size:25px;border:3px solid #e82f37;background-color:#e82f37;color:#fff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.nav-bar__button--disabled{opacity:0.5;cursor:default}.nav-bar__button--prev{float:left;padding-left:0px;background-color:#fff;color:#e82f37}.nav-bar__button--next{float:right;padding-right:0px}.nav-bar__arrow{padding:0 15px}\n", ""]);

// exports
